import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

function SearchBar() {
  const navigate = useNavigate();
  const [suggestions, setSuggestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const suggestionRef = useRef();

  const handleSearchParams = (e) => {
    e.preventDefault();
    if (searchTerm) navigate(`/admin/employees?search=${searchTerm}`);
  };

 
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchTerm(suggestion);
    setSuggestions([]);
    navigate(`/admin/employees?search=${suggestion}`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <form
      onSubmit={handleSearchParams}
      className="sm:w-72 bg-slate-200 sm:p-1 p-2 rounded-full flex items-center"
      ref={suggestionRef}
    >
      <input
        type="text"
        placeholder="Search Employees"
        className="bg-transparent focus:outline-none pl-3 pr-2 py-1.5 w-full text-sm"
        value={searchTerm}
        onChange={handleInputChange}
      />
      <button type="submit" className="p-1.5 flex-shrink-0">
        <FaSearch className="text-slate-600 text-sm" />
      </button>

      {/* Suggestions Dropdown */}
      {suggestions.length > 0 && (
        <ul className="absolute top-full mt-1 left-0 w-full bg-white border border-gray-200 shadow-lg rounded-md z-50 max-h-40 overflow-y-auto">
          {suggestions.map((sugg, idx) => (
            <li
              key={idx}
              onClick={() => handleSuggestionClick(sugg)}
              className="px-4 py-2 hover:bg-purple-100 cursor-pointer text-sm"
            >
              {sugg}
            </li>
          ))}
        </ul>
      )}
    </form>
  );
}

export default SearchBar;
